import { prisma, type Prisma } from "client";

// READ
export const getEventPages = async (
  eventId: string,
  orderBy: { order: "asc" | "desc" }
) => {
  const pages: any[] = [];
  // await prisma.page.findMany({
  //   where: {
  //     eventId,
  //   },
  //   orderBy: {
  //     order: orderBy.order,
  //   },
  //   // include: {
  //   //   components: true,
  //   // },
  // });

  return pages;
};

export const getPage = async (id: string) => {
  // const page = await prisma.page.findUnique({
  //   where: { id },
  //   // include: {
  //   //   components: true,
  //   // },
  // });

  return {};
};

// CREATE
export const createEventPage = async (
  eventId: string,
  pagePayload: any //Prisma.PageCreateInput
) => {
  const page = {};
  // await prisma.page.create({
  //   data: {
  //     ...pagePayload,
  //     event: {
  //       connect: {
  //         id: eventId,
  //       },
  //     },
  //     //   components: {},
  //   },
  //   // include: {
  //   //   components: true,
  //   // },
  // });

  return page;
};

export const createStartAndEndPages = async (eventId: string) => {
  // await prisma.page.createMany({
  //   data: [
  //     {
  //       title: "Start page",
  //       order: 1,
  //       html: "Hello from the start page",
  //       type: "STARTING_PAGE",
  //       path: "/",
  //       eventId,
  //     },
  //     {
  //       title: "End page",
  //       order: 2,
  //       html: "Hello from the end page",
  //       type: "ENDING_PAGE",
  //       path: "/confirmation",
  //       eventId,
  //     },
  //   ],
  // });
};

// UPDATE
export const updatePage = async (
  id: string,
  updatedData: any //Prisma.PageUpdateInput
) => {
  const page = {};
  // await prisma.page.update({
  //   where: {
  //     id,
  //   },
  //   data: {
  //     ...updatedData,
  //     //   components: {},
  //   },
  //   // include: {
  //   //   components: true,
  //   // },
  // });

  return page;
};

// DELETE
export const deletePage = async (id: string) => {
  const page = {};
  // await prisma.page.delete({
  //   where: {
  //     id,
  //   },
  //   // include: {
  //   //   components: true,
  //   // },
  // });

  return page;
};
